import React from 'react'
import "./Contact_map.css"
import Location_animation from '../../common-components/common-animation/location-animation/Location_animation'

const Contact_map = () => {
    return (
        <div className="map">
            <iframe
                className="gmap_iframe"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
                title="Google Map"
                loading='lazy'
                allowFullScreen
            ></iframe>

            <div className="view_div">
                <div className="location_div">
                    <Location_animation />
                    <p className='text'>View Map</p>
                </div>
            </div>
        </div>
    )
}

export default Contact_map